<template>
  <span v-if="hasMeasurements(measurements)">
    <b>H</b> {{ measurements.height }}mm ×
    <b>L</b> {{ measurements.length }}mm ×
    <b>D</b> {{ measurements.depth }}mm
  </span>
  <span v-else>
    <b>H</b> 65mm ×
    <b>L</b> 215mm ×
    <b>D</b> 102.5mm
  </span>
</template>

<script>
export default {
  props: {
    measurements: {
      type: Object | null,
      required: true,
    },
  },
  methods: {
    hasMeasurements(measurements) {
      return measurements
        && Number(measurements.height) !== 0
        && Number(measurements.length) !== 0
        && Number(measurements.depth) !== 0;
    }
  },
};
</script>
